<script>
  import authService from '@/services/security/hosted-auth.service'
  import emailService from '@/services/amio-api/email.service'
  import isEmail from 'validator/lib/isEmail'

  export default {
    mounted() {
      const email = this.$route.query.email
      authService.signUp(email)
    },

    beforeRouteEnter(to, from, next) {
      const email = to.query.email
      const action = 'enter_page'
      if (!email || !isEmail(email)) return next()

      emailService.logEmail(email, action)
        .then(() => next())
    }
  }
</script>
